import { withRouter } from 'react-router';
import GenericErrorSection from './GenericErrorSection';

export default withRouter(GenericErrorSection);
